import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Icon, Button } from 'shared/components';

import theme from './ModalEndConsultation.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  fullClinicianName: PropTypes.string.isRequired,
};

const ModalEndConsultation = ({
  intl,
  onOk,
  onCancel,
  fullClinicianName,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div className={ theme.iconContainer }>
        <Icon className={ theme.icon } name="disconnect-call" />
      </div>
      <div>
        <FormattedMessage id="app.stopConsultationModal.heading" defaultMessage="** End consultation?" />
      </div>
      <button onClick={ onCancel } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'EndConsultationDialog.CancelButton.TitleAttribute', defaultMessage: '** Close dialog, stay on call' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.content }>
      <FormattedMessage
        id="app.stopConsultationModalC2C.content"
        defaultMessage="** Are you sure you want to end your current consultation with { fullClinicianName }?"
        values={{
          fullClinicianName,
        }}
      />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-end-consultation-cancel-button"
        buttonType="naked"
        label={ intl.formatMessage({ id: 'const.button.cancel', defaultMessage: '** CANCEL' }) }
        ariaLabel={ intl.formatMessage({ id: 'EndConsultationDialog.CancelButton.TitleAttribute', defaultMessage: '** Close dialog, stay on call' }) }
        className={ theme.cancelButton }
        labelColor="blackMedium"
        onClick={ onCancel }
      />

      <Button
        testId="modal-end-consultation-end-button"
        label={ intl.formatMessage({ id: 'app.stopConsultationModal.okButton', defaultMessage: '** END CONSULTATION' }) }
        ariaLabel={ intl.formatMessage({ id: 'EndConsultationDialog.EndConsultationButton.TitleAttribute', defaultMessage: '** End call and close dialog' }) }
        iconName="hangout"
        background="red"
        onClick={ onOk }
        iconPositionLeft
      />
    </div>
  </div>
);

ModalEndConsultation.propTypes = propTypes;

export default ModalEndConsultation;
